<template>

    <div class="box box-solid">
        <div class="box-header">
            <h2 class="box-title">Contacten</h2>
            <div class="box-tools">
                <add-contact-button
                    :add-uri="route('api.v1.projects.contacts.store', {project_uuid: project.uuid})"
                    v-tooltip="'Contact toevoegen'"
                >
                    <i class="fa fa-plus"></i>
                </add-contact-button>
            </div>
        </div>
        <div class="box-body no-padding">
            <contacts-server-table
                v-if="loaded"
                :data-url="st.url"
                :data-columns="JSON.stringify(st.columns)"
                :preference-url="st.preferenceUrl"
            ></contacts-server-table>
        </div>
        <div class="overlay" v-if="!loaded">
            <i class="fa fa-refresh fa-spin"></i>
        </div>
    </div>

</template>

<script>

    import { mapGetters } from 'vuex';
    import Lang from '../../../Lang';
    import axios from 'axios';
    import ContactsServerTable from "../../../components/Projects/ContactsServerTable";
    import AddContactButton from "../../../components/Projects/AddContactButton";

    export default {

        components: {
            ContactsServerTable,
            AddContactButton,
        },

        computed: {
            ...mapGetters([
                'getProject',
            ]),

            project() {
                return this.getProject;
            },
        },

        data() {
            return {
                Lang:Lang,
                loaded:false,
                st: {
                    columns:[],
                    url:'',
                    preferenceUrl:'',
                },
            }
        },

        metaInfo: {
            title:'Project contacten',
        },

        methods: {
            getProjectContacts() {
                axios.get(this.route('api.v1.projects.contacts.st', {project_uuid: this.project.uuid}))
                    .then(resp => {
                        this.st = resp.data;
                        this.loaded = true;
                    })
            },
        },

        mounted(){
            this.getProjectContacts();
        },

        name:'ProjectsDetailsContacts',

    }

</script>
